import { render, staticRenderFns } from "./DeliveryAddressNewFormSubmits.vue?vue&type=template&id=f65b1718&"
import script from "./DeliveryAddressNewFormSubmits.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewFormSubmits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports